import BedSection from './BedSection';

export default BedSection;
